module.exports = __webpack_public_path__ + "static/media/PonteOn.69dced1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/gbadicionales/PonteOn.svg
// module id = 754
// module chunks = 0